import React from 'react';
import { Helmet } from 'react-helmet';
import bannerBg from '../assets/img/page-banner.jpg';
import ContactUs from '../components/ContactUs';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';

function Contact() {
    return (
        <>
            <Helmet>
                <title>Contact - Work Express | Solicită Ofertă Construcții București</title>
                <meta name="description" content="Contactează Work Express pentru servicii de construcții și renovări în București. Telefon: 0724.273.258 | Email: office@reparatiiasfalt.ro. Solicită o ofertă personalizată." />
                <meta name="keywords" content="contact work express, oferta constructii bucuresti, telefon constructii, email work express, solicita oferta" />
                <meta property="og:title" content="Contactează Work Express - Construcții București" />
                <meta property="og:description" content="Solicită o ofertă personalizată pentru proiectul tău de construcții sau renovări." />
                <link rel="canonical" href="https://workexpress.ro/contact" />
            </Helmet>
            <Header1 />
            <PageBanner bannerBg={bannerBg} heading="Contact" currentPage="Contact" />
            <ContactUs />
            <Footer1 />
        </>
    );
}

export default Contact;
